import { createApp } from 'vue';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import './style.css';
import './assets/styles/iconfont.css';
import '@/assets/styles/index.scss'; // global css
import store from '@/store';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import { zhCn } from 'element-plus/es/locale/index.mjs';
import { padZero,getMessageType,handleTimeRange_edit2,formatTime100,parseTime99,parseTime, handleTimeRange_send,handleTimeRange_creat,handleTimeRange,handleTimeRange_submit,handleTimeRange_update,formatDate,handleTimeRange_pace,handleTimeRange_edit} from "./utils/base";
import App from './App.vue';
import router from './router';
import './permission' // permission control
import Pagination from "@/components/Pagination";
import tab from '@/plugins/tab.js';
import modal from '@/plugins/modal.js';
import request from '@/utils/request'
import download from '@/plugins/download.js'
import RightToolbar from "@/components/RightToolbar"
import svgStyle from '@/components/svgStyle';
const app = createApp(App);
app.config.globalProperties.$parseTime=parseTime;
app.config.globalProperties.$handleTimeRange=handleTimeRange;
app.config.globalProperties.$handleTimeRange_creat=handleTimeRange_creat;
app.config.globalProperties.$handleTimeRange_submit=handleTimeRange_submit;
app.config.globalProperties.$handleTimeRange_update=handleTimeRange_update;
app.config.globalProperties.$formatDate=formatDate;
app.config.globalProperties.$handleTimeRange_pace=handleTimeRange_pace;
app.config.globalProperties.$handleTimeRange_edit=handleTimeRange_edit;
app.config.globalProperties.$handleTimeRange_send=handleTimeRange_send;
app.config.globalProperties.$parseTime99=parseTime99;
app.config.globalProperties.$formatTime100=formatTime100;
app.config.globalProperties.$getMessageType=getMessageType;
app.config.globalProperties.$handleTimeRange_edit2=handleTimeRange_edit2;
app.config.globalProperties.$tab = tab;
app.config.globalProperties.$download = download;
app.config.globalProperties.$modal = modal;
app.config.globalProperties.$request = request;
app.config.globalProperties.$padZero = padZero;
app.config.globalProperties.$sourceurl = 'https://service.nutrient-top.cn';
app.use(store);
app.use(router);
app.use(ElementPlus,{locale:zhCn});
app.component('Pagination', Pagination);
app.component('RightToolbar', Pagination);
app.component('svgStyle', svgStyle);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component);
  }
app.mount('#app');
